/* eslint-env node */

module.exports = require('./dist/commonjs/full');
